module.exports = __webpack_public_path__ + "img/long-color@3x copy.fa829953.png";